/**
 * Procedure Categories and Procedures for MD in Family Medicine students
 * Extracted with strict evidence from official NMC PDF (Page 8-12: "perform the following skills")
 */
export const FAMILY_MEDICINE_PROCEDURES = {
  "Emergency & General Medical Procedures": [
    "Cardiopulmonary Resuscitation (BLS / ACLS / Defibrillation)",
    "Endotracheal Intubation & Airway Management",
    "Chest-Tube Drainage with Under-Water Seal",
    "Abdominal Paracentesis & Pleural Fluid Aspiration",
    "Lumbar Puncture & Cerebrospinal Fluid (CSF) Examination",
    "Nasogastric Intubation & Urinary Bladder Catheterization",
    "Intravenous Access & Venesection",
    "Basic Hematology & Staining (Hb, TLC, DLC, ESR, AFB Smear)",
    "Local, Regional & Spinal Anaesthesia Administration",
    "Neonatal Resuscitation",
  ],
  "Surgical, Orthopaedic & Minor Specialty Procedures": [
    "Incision and Drainage of Abscess",
    "Wound Suturing, Dressing, and Bandaging",
    "Fine Needle Aspiration Cytology (FNAC)",
    "Excision & Biopsy of Superficial Swellings",
    "Proctoscopy",
    "Foreskin Dorsal Slit, Circumcision & Reduction of Paraphimosis",
    "Vasectomy & Hydrocelectomy",
    "Suprapubic Cystostomy",
    "Splinting & Application of Orthopaedic Casts",
    "Removal of Wax / Foreign Body from Ear & Nose, Nasal Packing & Ear Syringing",
    "Tracheostomy & Cricothyroidotomy",
    "Ophthalmic Epilation & Removal of Superficial Foreign Body",
    "Dermatological Electrocautery, Chemical Cauterization & Skin Biopsy",
  ],
  "Maternal & Women's Health Procedures": [
    "Conduct of Normal Delivery",
    "Lower Segment Caesarean Section (LSCS) Performance",
    "Vacuum & Forceps Assisted Delivery",
    "Pap Smear Collection",
    "Cervical & Endometrial Biopsy",
    "Dilatation and Curettage (D&C)",
    "Insertion and Removal of Intrauterine Contraceptive Device (IUCD)",
    "Medical Termination of Pregnancy (MTP)",
  ],
};

export const FAMILY_MEDICINE_CATEGORIES = Object.keys(FAMILY_MEDICINE_PROCEDURES);

export const isMDInFamilyMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("family medicine") || d.includes("general practice");
};
